import '../../platform.css';
import './settings.css';

import { useRecoilValue } from 'recoil';
import { userConfigState } from '../../recoil/atoms/userConfigState';
import { navigationPropsState } from '../../recoil/atoms/navigationPropsState';
import { useSetNavigationProps } from '../../recoil/hooks/useSetNavigationProps';
import { useOpenGlobalModal } from '../../recoil/hooks/useOpenGlobalModal';

import AccountCircle from '@mui/icons-material/AccountCircle';
import GroupsIcon from '@mui/icons-material/Groups';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import HelpIcon from '@mui/icons-material/Help';

import { Account } from './Account';
import { ClubSettings } from './ClubSettings';
import { Support } from './Support';
import { RoleConfigs } from './RoleConfigs';
import { FixedTabs } from '../../components/controls/navigation/FixedTabs';
import { StringToElementMap } from '../../types/common';
import { Formations } from './Formations';


export const Settings: React.FC = () => {

  const userConfig = useRecoilValue(userConfigState);
  const { openConfirmModal } = useOpenGlobalModal();

  const updateNavigationProps = useSetNavigationProps();
  const navigationProps = useRecoilValue(navigationPropsState);


  const tabOptions = [ 'account', 'club'];
  if (userConfig?.accessConfig.hasAccessToScouting || userConfig?.accessConfig.hasAccessToManageFormations) {
    tabOptions.push('formations');
  }
  if (userConfig?.accessConfig.hasAccessToScouting || userConfig?.accessConfig.hasAccessToManageRoles) {
    tabOptions.push('roles');
  }
  tabOptions.push('help');

  const tabOptionToTabIcon: StringToElementMap = {
    'account': <AccountCircle style={{ fontSize: 22 }} />,
    'club': <GroupsIcon style={{ fontSize: 22 }} />,
    'formations': <ScatterPlotIcon style={{ fontSize: 22 }} />,
    'roles': <InsertChartOutlinedIcon style={{ fontSize: 22 }} />,
    'help': <HelpIcon style={{ fontSize: 22 }} />
  };


  const activeSubTab = navigationProps.activeSettingsSubTab ?? 0;
  const setActiveSubTab = (subTab: number) => {
    updateNavigationProps({ activeSettingsSubTab: subTab }, true);
  };

  const openConfirmExitConfigModal = (subTab: number, title: string) => openConfirmModal(
    () => setActiveSubTab(subTab),
    title + '?',
    title + 'Info'
  );


  const handleSubTabClick = (subTab: number) => {
    if (navigationProps.roleConfigHasUnsavedChanges) {
      openConfirmExitConfigModal(subTab, 'exitRole');
    }
    else if (navigationProps.formationConfigHasUnsavedChanges) {
      openConfirmExitConfigModal(subTab, 'exitFormation');
    }
    else {
      setActiveSubTab(subTab);
    }
  };

  return (
    <div className='platform-view-section'>

      <FixedTabs
        tabOptions={tabOptions}
        activeTab={activeSubTab}
        setActiveTab={handleSubTabClick}
        parentTab={'settings'}
        tabIcons={tabOptions.map(tabOption => tabOptionToTabIcon[tabOption])}
      />

      <div className='platform-view-content-container-with-tabs'>
        {tabOptions[activeSubTab] === 'account' && <Account />}

        {tabOptions[activeSubTab] === 'club' && <ClubSettings />}

        {tabOptions[activeSubTab] === 'formations' && <Formations />}

        {tabOptions[activeSubTab] === 'roles' && <RoleConfigs />}

        {tabOptions[activeSubTab] === 'help' && <Support />}
      </div>

    </div>
  );
};
